import request from 'superagent'

const cache = {}

/**
 * Parse the URL args to get the API url.
 *
 * @since  5.15.25
 *
 * @param  {Object} args Arguments for the request.
 *
 * @returns {string}      URL
 */
const parseUrl = args => {
	if ('object' !== typeof args) {
		return args
	}

	if (args.url) {
		return args.url
	}

	return ''
}

/**
 * Parse the given args into a usable set of arguments for the request.
 *
 * @since  5.15.25
 *
 * @param  {string} method The request method.
 * @param  {Object} args   Arguments for the request.
 *
 * @returns {Object}      Arguments for the request.
 */
const parseArgs = (method, args) => {
	const url = parseUrl(args)
	if ('object' !== typeof args) {
		args = {}
	}
	args.url = url
	args.method = method

	const defaults = {
		cached : 'get' === method
	}
	args = { ...defaults, ...args }

	return args
}

/**
 * Performs a request to the OM api.
 *
 * @since  5.15.25
 *
 * @param  {string} method The request method.
 * @param  {Object} args   Arguments for the request.
 *
 * @returns {Promise}       Returns the request promise.
 */
const makeRequest = (method = 'get', args) => {
	args = parseArgs(method, args)
	const { url } = args
	const cacheKey = url + method

	if (!args.cached || !cache[cacheKey] || cache[cacheKey]._aborted) {
		cache[cacheKey] = request[method](url).on('abort', () => delete cache[cacheKey])
	}

	return cache[cacheKey]
}

/**
 * Performs a get request to the OM api.
 *
 * @since  5.15.25
 *
 * @param  {Object} args Arguments for the request.
 *
 * @returns {Promise}     Returns the request promise.
 */
const getRequest = args => makeRequest('get', args)

/**
 * Performs a post request to the OM api.
 *
 * @since  5.15.25
 *
 * @param  {Object} args Arguments for the request.
 *
 * @returns {Promise}     Returns the request promise.
 */
const postRequest = args => makeRequest('post', args)

/**
 * Performs a put request to the OM api.
 *
 * @since  5.15.25
 *
 * @param  {Object} args Arguments for the request.
 *
 * @returns {Promise}     Returns the request promise.
 */
const putRequest = args => makeRequest('put', args)

/**
 * Performs a delete request to the OM api.
 *
 * @since  5.15.25
 *
 * @param  {Object} args Arguments for the request.
 *
 * @returns {Promise}     Returns the request promise.
 */
const deleteRequest = args => makeRequest('delete', args)

export default {
	get     : getRequest,
	post    : postRequest,
	put     : putRequest,
	delete  : deleteRequest,
	request : makeRequest
}
